import {config} from '../config';

export default {
    getIsDeviceListEnabled: () => config.data.consumerServices.isDeviceListEnabled,
    getIsDeviceRegistrationEnabled: () => config.data.consumerServices.isDeviceRegistrationEnabled,
    getIsDeviceRenameEnabled: () => config.data.consumerServices.isDeviceRenameEnabled,
    getIsDeviceUnregistrationEnabled: () => config.data.consumerServices.isDeviceUnregistrationEnabled,
    getIsTNCEnabled: () => config.data.consumerServices.isTNCEnabled,
    getIsUnitedTNCEnabled: () => config.data.consumerServices.isUnitedTNCEnabled,
    getIsNonMandatoryRegistrationEnabled: () => config.data.consumerServices.isNonMandatoryRegistrationEnabled,
    getIsRegistrationPromoted: () => config.data.consumerServices.isRegistrationPromoted,
};
